/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import Skeleton from 'react-loading-skeleton';
import { Mutation, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import {
  dissoc,
} from 'ramda';
import { RoleBuilder } from '@iris-platform/protektor';
import { GET_ALL_ROLES, GET_ALL_ROLES_PAGINATED } from './RolesContainer';
import { PROTEKTOR_DELETE, PROTEKTOR_UPDATE } from '../../../utils/protektorConstants';


const REMOVE_ROLE = gql`
mutation($roleIdentifier:InputRoleIdentifier!) {
  removeRole(roleIdentifier:$roleIdentifier) {
    roleIdentifier {
      name
      displayName
      team
    }
    permissions {
      action
      resource
      allowed
    }
  }
}
`;
const SEARCH_TEAMS = gql`
query searchTeams($filter: String!, $skip: Int!, $limit: Int!) {
  searchTeams(filter: $filter, skip: $skip, limit: $limit) {
    team_id
    display_name
  }
}
`;
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 400,
    borderSpacing: '0px 7px',
    marginBottom: '2em',
  },
  heading: {
    backgroundColor: '#2b9cd8',
    fontSize: '24px',
    fontWeight: '500',
    lineHeight: '60px',
  },
  headContent: {
    color: '#fff',
    lineHeight: '41px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'left',
    position: 'relative',
    textDecoration: 'none',
    borderBottom: 'none',
  },
  content: {
    lineHeight: '41px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'left',
    position: 'relative',
    textDecoration: 'none',
    borderBottom: 'none',
  },
  contentEnd: {
    lineHeight: '41px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'right',
    position: 'relative',
    textDecoration: 'none',
    borderBottom: 'none',
  },
  title: {
    color: '#1682bc',
    paddingLeft: '45px',
    fontSize: '24px',
  },
  OddRow: {
    backgroundColor: '#f6f6f6',
    marginLeft: '5px',
  },
  button: {
    backgroundColor: '#1eb368',
    padding: '5px 10px',
    borderRadius: '3px',
    border: '0px',
    color: '#fff',
    width: 76,
    height: 25,
    fontSize: 13,
  },
  gradientButton: {
    marginTop: '1rem',
    fontSize: '14px',
    marginRight: '10px',
  },
  link: {
    paddingTop: '15px',
  },
});

const withoutTypename = dissoc('__typename');
const teamIdMap = {};
class ListRoles extends Component {
  constructor(props) {
    super(props);
    this.loadTeamIdMapping();
  }

  loadTeamIdMapping = async () => {
    const teams = this.fetchTeams('');
    await teams.then((data) => {
      data.map((team) => {
        const teamId = team.team_id;
        teamIdMap[teamId] = team.display_name;
      });
    });
    this.forceUpdate();
  };

  fetchTeams = async (searchString) => {
    const { client } = this.props;
    try {
      const {
        data: { searchTeams: teams },
      } = await client.query({
        query: SEARCH_TEAMS,
        variables: {
          filter: searchString,
          skip: 0,
          limit: 20,
        },
      });
      return teams;
    } catch (error) {
      console.error('Error occurred while fetching the teams', error);
    }
  };

  renderLoading = ({ classes, title }) => (
    <Table className={classes.table}>
      <TableHead>
        <TableRow className={classes.heading}>
          <TableCell className={classes.headContent}>Role Name</TableCell>
          <TableCell className={classes.headContent}>Type</TableCell>
          <TableCell className={classes.headContent}>Id</TableCell>
          <TableCell className={classes.headContent} />
        </TableRow>
      </TableHead>
      <TableBody>
        {Array(10)
          .fill(null)
          .map((val, i) => (
            <TableRow key={i}>
              <TableCell>
                <Skeleton />
              </TableCell>
              <TableCell>
                <Skeleton />
              </TableCell>
              <TableCell>
                <Skeleton />
              </TableCell>
              <TableCell>
                <Skeleton />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );

  render() {
    const {
      classes, roles, title, isLoading, filter, skip, limit, roleProp,
    } = this.props;

    if (isLoading) {
      return this.renderLoading(this.props);
    }

    const permRole = RoleBuilder.fromJSON(roleProp);

    return (
      <Mutation mutation={REMOVE_ROLE}>
        {(removeRole, error, loading) => (
          <React.Fragment>
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.heading}>
                  <TableCell className={classes.headContent}>Role Name</TableCell>
                  <TableCell className={classes.headContent}>Type</TableCell>
                  <TableCell className={classes.headContent}>Id</TableCell>
                  <TableCell className={classes.headContent} />
                </TableRow>
              </TableHead>
              <TableBody>
                {roles.map((role, idx) => (
                  <TableRow
                    key={role.roleIdentifier.name}
                    className={idx % 2 === 1 ? classes.OddRow : ''}
                  >
                    <TableCell className={classes.content}>
                      {role.roleIdentifier.displayName}
                    </TableCell>
                    <TableCell className={classes.content}>
                      {teamIdMap[role.roleIdentifier.team]}
                    </TableCell>
                    <TableCell className={classes.content}>{role.roleIdentifier.name}</TableCell>
                    <TableCell className={classes.contentEnd}>
                      <Tooltip
                        id="tooltip-top-start"
                        title="Edit"
                        placement="top"
                      >
                        {(permRole.hasPermission({ action: PROTEKTOR_UPDATE, resource: 'PlatformRoles' }) ? (
                          <Link
                            to={`/dashboard/platformroles/${role.roleIdentifier.name}/${role.roleIdentifier.team}/edit`}
                            className={classes.link}
                          >
                            <IconButton aria-label="Edit">
                              <EditIcon />
                            </IconButton>
                          </Link>
                        ) : (
                          <IconButton
                            aria-label="Edit"
                            disabled
                          >
                            <EditIcon />
                          </IconButton>
                        ))}

                      </Tooltip>
                      <Tooltip id="tooltip-top-start" title="Delete" placement="top">
                        <IconButton
                          aria-label="Close"
                          disabled={loading || !permRole.hasPermission({ action: PROTEKTOR_DELETE, resource: 'PlatformRoles' })}
                          onClick={() => removeRole(
                            {
                              variables: {
                                roleIdentifier: withoutTypename(role.roleIdentifier),
                              },
                              refetchQueries: [
                                {
                                  query: GET_ALL_ROLES_PAGINATED,
                                  variables: { filter, skip, limit },
                                }, {
                                  query: GET_ALL_ROLES,
                                },
                              ],
                            },
                          )
                          }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </React.Fragment>
        )}
      </Mutation>
    );
  }
}

ListRoles.propTypes = {
  classes: PropTypes.object.isRequired,
  roles: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default withStyles(styles)(withApollo(ListRoles));
